// Configuration for portal URLs
// Reads from environment variables with safe fallbacks

const userPortalEnv = process.env.REACT_APP_USER_PORTAL_URL;
const clientPortalEnv = process.env.REACT_APP_CLIENT_PORTAL_URL;

// Fallbacks to current behavior if env is not defined
const devUserDefault = 'http://localhost:3001';
const devClientDefault = 'http://localhost:3002';
const prodUserDefault = 'https://app.pixano.ai';
const prodClientDefault = 'https://marketplace.pixano.ai';

const isDev = process.env.NODE_ENV === 'development';

export const USER_PORTAL_URL =
  userPortalEnv ||
  (isDev ? devUserDefault : prodUserDefault);

export const CLIENT_PORTAL_URL =
  clientPortalEnv ||
  (isDev ? devClientDefault : prodClientDefault);

// Legacy export for backward compatibility (if needed)
export const portalUrls = {
  userPortal: USER_PORTAL_URL,
  clientPortal: CLIENT_PORTAL_URL,
};

